import { Bot, Building, DollarSign, Flag, LayoutDashboard } from 'lucide-react'

type NavItem = {
  title: string
  url: string
  icon: React.ElementType
  alternativeUrls?: string[]
  disabled?: boolean
}

const navItems: NavItem[] = [
  {
    title: 'Dashboard',
    url: '/',
    icon: LayoutDashboard,
    disabled: false,
  },
  {
    title: 'Organizations',
    url: '/organizations',
    icon: Building,
    disabled: false,
  },
  {
    title: 'Feature Flags',
    url: '/feature-flags',
    icon: Flag,
    disabled: false,
  },
  {
    title: 'Pricing',
    url: '/pricing',
    icon: DollarSign,
    disabled: false,
  },
  {
    title: 'Banjo',
    url: '/banjo',
    icon: Bot,
    disabled: false,
  },
]

export default navItems
